import React from "react";
import { Box, Typography } from "@mui/material";

import { APP_BAR_CHROME_ICON_BUTTON_SX } from "./constants";
import BackButton from "./BackButton";

/**
 * Mobile Prompts-style header: single row with back, ellipsized title, and right-slot actions.
 * @param {object} props
 * @param {{ onClick: () => void, icon?: import("react").ReactNode, ariaLabel?: string } | null | undefined} props.backAction
 * @param {string | null | undefined} props.title
 * @param {import("react").ReactNode[]} props.rightComponents - Nodes rendered in the trailing action cluster.
 * @param {string[]} props.rightKeys - React keys aligned with `rightComponents`.
 * @returns {import("react").JSX.Element}
 */
export default function MobilePromptHeaderInline({ backAction, title, rightComponents, rightKeys }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: "100%",
        minWidth: 0,
        px: { xs: 0.5, sm: 0 },
      }}
    >
      <BackButton backAction={backAction} sx={{ ...APP_BAR_CHROME_ICON_BUTTON_SX, flexShrink: 0, mr: 0 }} />
      <Typography
        component="h1"
        sx={{
          flex: "1 1 0%",
          minWidth: 0,
          textAlign: "left",
          fontSize: { xs: "1.125rem", sm: "1.2rem" },
          fontWeight: 700,
          letterSpacing: "-0.02em",
          color: "#000000",
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          userSelect: "none",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          flexWrap: "nowrap",
          gap: 0.75,
          flexShrink: 0,
          minWidth: 0,
        }}
      >
        {rightComponents.map((component, i) => (
          <Box key={rightKeys[i]} sx={{ display: "flex", alignItems: "center" }}>
            {component}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
